import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-068e458f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-ziyuan1" }, null, -1))
const _hoisted_3 = { class: "categories" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import articles, { State } from '@/store/articles/home';
import i18, { State as I18State } from '@/store/i18';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[articles.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].article)

function onSelected(key: string) {
    articles.setCategory(store, key)
    data.value.feedsVisible = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).channel), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).categories, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass(["navigator", { on: item.username == _unref(data).category }]),
          onClick: ($event: any) => (onSelected(item.username))
        }, [
          _createElementVNode("img", {
            src: item.logo
          }, null, 8, _hoisted_5),
          _createElementVNode("span", null, _toDisplayString(item.passport), 1)
        ], 10, _hoisted_4))
      }), 256))
    ])
  ]))
}
}

})